import helpers from "@/common/utils/helpers";
export default {
    'producao-cientifica' : {
        titulo : 'Produção Científica',
        colunas : [
            { key: 'tipo', label: "Tipo",
                formatter: (value) => {
                    if (value) return  helpers.getEnum(value).text;
                },
            },
            { key: "dataPublicacao", label:"Data",
                formatter: (value) => {
                    if (value) return helpers.formatarDataBr(value);
                },
            },
            { key: "nomeDaPublicacao", label: "Nome da publicação", },
            { key: "pais", label: "Pais", },
            { key: "titulo", label: "Titulo", },
        ]
    },
    'capacitacao-profissional' : {
        titulo : 'Capacitação Profissional',
        colunas : [
            { key: 'tipo', label: "Tipo",
                formatter: (value) => {
                    if (value) return  helpers.getEnum(value).text;
                },
            },
            { key: "dataConclusao", label:"Data",
                formatter: (value) => {
                    if (value) return helpers.formatarDataBr(value);
                },
            },
            { key: "areaPesquisa", label: "Nome da publicação", },
        ]
    },
}